import { MoreHorizontal, Trash2 } from 'lucide-react'

import { Button } from 'src/shared/components/ui/buttons/button'
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuTrigger,
} from 'src/shared/components/ui/popups/dropdown-menu'
import { useMyUserData } from 'src/shared/features/users/api/accounts/use-my-user'
import type { Reaction, StreamPost } from 'src/shared/schemas/stream/feed'

interface PostOptionsMenuProps {
  post?: StreamPost
  comment?: Reaction
  onEdit?: () => void
  onDelete?: () => void
}

export const PostOptionsMenu = ({ post, comment, onDelete }: PostOptionsMenuProps) => {
  const { data: currentUser } = useMyUserData()
  const isAuthor = currentUser?.id === parseInt(post?.actor.id || comment?.userId || '')
  const isAdmin = currentUser?.role === 'admin'

  if (!isAuthor && !isAdmin) {
    return null
  }

  return (
    <DropdownMenu>
      <DropdownMenuTrigger asChild>
        <Button variant="ghost" size="icon" className="size-4" onClick={(e) => e.stopPropagation()}>
          <MoreHorizontal className="size-4" />
        </Button>
      </DropdownMenuTrigger>
      <DropdownMenuContent align="end">
        <DropdownMenuItem
          onClick={(e) => {
            e.stopPropagation()
            onDelete?.()
          }}
        >
          <Trash2 className="size-4" />
          Delete
        </DropdownMenuItem>
      </DropdownMenuContent>
    </DropdownMenu>
  )
}
